export default __webpack_public_path__ + "static/media/icon-error.054702dd.png";